import {
	mapGetters,
	mapActions
} from 'vuex';

import {
	panel,
	accordion
} from 'vue-strap';

import {
	DatePicker
} from 'element-ui';

import {
	cloneDeep
} from 'lodash';

import moment from 'moment';

import {
	EventBus
} from '@/support/event-bus';

import TextareaCounter from '@/components/textarea-counter/textarea-counter';
import HomeworkSave from '@/domains/homework/save/save';
import HomeworkCopy from '@/domains/homework/copy/copy';
import HomeworkPublish from '@/domains/homework/publish/publish';
import HomeworkPublishAll from '@/domains/homework/publish-all/publish-all';

export default {
	name: 'homework-themes',
	components: {
		panel,
		accordion,
		DatePicker,
		HomeworkSave,
		HomeworkPublish,
		HomeworkPublishAll,
		HomeworkCopy,
		TextareaCounter
	},
	data: () => ({
		datepicker: {
			today: new Date()
		},
		themes: [],
		exclusiveThemes: []
	}),
	props: {
		context: {
			type: String,
			default: ''
		}
	},
	computed: {
		...mapGetters([
			'getLoggedUser',
			'getAgendaDate',
			'getHomeworkList',
			'getClass',
			'getHomeworkId',
			'getAgendaExclusiveHomework'
		])
	},
	methods: {
		...mapActions([
			'getHomeworkBySchoolClass',
			'setHomeworkList',
			'putHomeworkItemByKey',
			'saveHomeworkBySchoolClass',
			'putExclusiveHomeworkItemByKey'
		]),
		putHomeworkItem(index, theme) {
			console.log(index);
			if (this.context === 'exclusiveHomework') {
				this.putExclusiveHomeworkItemByKey({
					index,
					theme
				});
			} else {
				this.putHomeworkItemByKey({
					index,
					theme
				});
			}
		},
		hasHomework() {

			const {
				schoolClassLevel
			} = this.getClass;

			return schoolClassLevel === 'Infantil' || schoolClassLevel === 'Fundamental_1' || schoolClassLevel === 'Fundamental_2' || schoolClassLevel === 'EnsinoMedio';

		},
		getHomework(payload) {

			this.getHomeworkBySchoolClass(payload).then((data) => {

				if (data && data.themes) {

					data.themes.forEach((value, key) => {

						if (!value.title) {
							data.themes[key].title = "";
						}

						if (!value.homework) {
							data.themes[key].homework = "";
						}

						if (!value.dueDate) {
							data.themes[key].dueDate = null;
						}

					});

					this.setHomeworkList(data);
					this.themes = cloneDeep(this.getHomeworkList);

					this.themes.map((theme) => {

						theme.dueDate = moment(theme.dueDate, 'YYYY-MM-DD').toISOString();

						return theme;

					});

				}

			});

		}
	},
	directives: {
		altmodel: {
			bind: function (el, binding, vnode) {
				el.oninput = () => (vnode.context[binding.expression] = el.value);
			}
		}
	},
	created() {

		EventBus.$on('homeworkSaved', () => {
			this.themes = cloneDeep(this.getHomeworkList);
		});

		EventBus.$on('homeworkPublished', () => {
			this.themes = cloneDeep(this.getHomeworkList);
		});

		EventBus.$on('setAgenda', () => {
			this.exclusiveThemes = cloneDeep(this.getAgendaExclusiveHomework);
		});

	},
	mounted() {

		this.$store.watch((state) => state.Class.selected, (newClass) => {

			if (newClass && newClass.schoolClassId && this.hasHomework()) {

				this.getHomework({
					userId: this.getLoggedUser.id,
					schoolClassId: newClass.schoolClassId,
					agendaDate: moment(this.getAgendaDate).format('YYYY-MM-DD')
				});

			}

		});

		this.$store.watch((state) => state.Agenda.date, (newDate) => {

			if (newDate && this.getClass.schoolClassId && this.hasHomework()) {

				this.getHomework({
					userId: this.getLoggedUser.id,
					schoolClassId: this.getClass.schoolClassId,
					agendaDate: moment(this.getAgendaDate).format('YYYY-MM-DD')
				});

			}

		});

	},
	beforeDestroy() {

		EventBus.$off('homeworkSaved');
		EventBus.$off('homeworkPublished');
		EventBus.$off('setAgenda');

	}

};


// WEBPACK FOOTER //
// ./sources/domains/homework/themes/index.js